import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromGuidelinesNotSavedChanges from './state/guidelines-not-saved-changes.reducer';
import { GuidelinesNotSavedChangesFacade } from './state/guidelines-not-saved-changes.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromGuidelinesNotSavedChanges.GUIDELINES_NOT_SAVED_CHANGES_FEATURE_KEY,
      fromGuidelinesNotSavedChanges.guidelinesNotSavedChangesReducer
    ),
  ],
  providers: [GuidelinesNotSavedChangesFacade],
})
export class GuidelinesNotSavedChangesModule {}
